<h2 mat-dialog-title><fa-icon [icon]="warningIcon" style="color: orange;"></fa-icon> Passenger Notice</h2>
<mat-dialog-content class="mat-typography">
  <h4>
    The system indicates that the passengers below have not
    checked in.
  </h4>
  <ul *ngFor="let passenger of passengersNotCheckedIn">
    <li class="passenger-warning-text">{{passenger.role}} - {{passenger.firstName}} {{passenger.lastName}}</li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-flat-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>Continue Pickup</button>
</mat-dialog-actions>
